import { Component, OnInit } from '@angular/core';
import { TaComunicazioniService } from './ta-comunicazioni.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'ta-comunicazioni',
  templateUrl: './ta-comunicazioni.component.html',
  styleUrls: ['./ta-comunicazioni.component.scss'],
  providers: [TaComunicazioniService]
})
export class TaComunicazioniComponent implements OnInit {
  

  modelList: any[];
  articolo: any = {};
  promiseBusy: Promise<any[]>;
  refreshData: boolean = false;
  imgArray: any[];

  imageOptions = [
    { id: 1, title: 'Default image', src: './assets/images/placeholder_news_default.webp' },
    { id: 2, title: 'Bollettino', src: './assets/images/placeholder_bollettino.webp' },
    { id: 3, title: 'Avviso', src: './assets/images/placeholder_avviso.webp' }
  ];
  getImageTitleById(id: number): string {
    const found = this.imageOptions.find(opt => opt.id === id);
    return found ? found.title : 'placeholder';
  }
  getImageSrcById(id: number): string {
    const found = this.imageOptions.find(opt => opt.id === id);
    return found ? found.src : './assets/images/placeholder_news_default.webp';
  }
  constructor(public restService: TaComunicazioniService, 
    private router: Router) {
  }
  
  ngOnInit() {
    this.createArticoliList();
  }

  ngAfterViewChecked() {
    if (this.refreshData) {
      this.refreshData = false;
    }
  }

  createArticoliList() {
    this.restService.findLastTwo().then(res => {
      if (res != null) {
        this.modelList = res.articoliBindList;
  
        this.refreshData = true;
      }
    }).catch(error => {
      this.modelList = [];
      this.refreshData = true;
    });
  }
  

  findById(idArticolo: any) {
    this.promiseBusy = this.restService.findById(idArticolo);
    this.promiseBusy.then(
      res => {
        this.articolo = res;
        this.articolo.imgUrl = 'img/articoli/' + this.articolo.imgUrl;
        this.refreshData = true;
      }
    ).catch(error => {
    });
  }

  /* routeTo(string) {
    window.location.href = string;
  } */
    routeTo(idArticolo: number) {
      this.router.navigate(['/news/'+idArticolo]);  
    }
}
